import React from "react"

export function TestSettings() {
  return <div data-testid="test-block-settings">TestSettings</div>
}
